import React, { Component } from 'react';
import { Spin, Table, Button, Icon, InputNumber, Modal, Card, Tooltip } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import InventarioRequest from '../../services/Inventario';
const { confirm } = Modal;

/**
 * Evento para cancelar el scroll en input number
 */
document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

/**
 * Clase para ver el detalle de un inventario
 */
export default class DetallesSAP extends Component {
    state = {
        arrDocsInventario: [],
        folioSAP: "",
        filterText: "",
        cargando: false,
        arrDrives: [],
        driveSelected: null,
        scroll: { x: '100%', y: 400 },
        bloquearBotones: false,
        paginacion: {},
        dataErrors: [],
        filtros: {
            filtro: undefined,
            page: undefined
        }
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        if(this.props.visible){
            let state = { ...this.state }
            if (this.props.inventario !== prevProps.inventario) {
                if (this.props.inventario) {
                    this.setState({ cargando: true }, () => {
                        InventarioRequest.DetalleInventarioSAP(this.props.inventario?.id).then(response => {
                            state.cargando = false;
                            state.folioSAP = response.data.FolioSAP;
                            state.arrDocsInventario = response.data.Documentos;
                            state.dataErrors = response.data.ErroresSAP;
                            this.setState(state)
                        }).catch(err => {
                            this.setState({ cargando: false })
                            openNotification(
                                err?.response?.cuerpo,
                                err?.response?.titulo ?? 'Error'
                            )
                        })
                    })
                }
            }
        }
    }

    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        state.paginaSiguiente = paginaSiguiente
        state.filtros.page = paginaSiguiente
        state.cargando = true
        this.setState({ cargando: true }, () => {
            InventarioRequest.DetalleInventarioSAP(this.props.inventario?.id,paginaSiguiente)
                .then(response => {
                    state.cargando = false;
                    state.folioSAP = response.data.FolioSAP;
                    state.arrDocsInventario = response.data.Documentos;
                    state.dataErrors = response.data.ErroresSAP;
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        err?.response?.cuerpo,
                        err?.response?.titulo ?? 'Error'
                    )
                })
        })
    }


    render() {
        const columnasErr = [
            {
                title: "Error Registro",
                dataIndex: "statxtField",
                key: "statxtField",
                width: 6,
                render: statxtField => {
                    return (
                        <span> {statxtField} </span>
                    )
                }
            }
        ]

        const columnasDocs = [
            {
                title: "Documento",
                dataIndex: "Documento",
                key: "Documento",
                width: 6,
                render: Documento => {
                    return (
                        <span> {Documento} </span>
                    )
                }
            },
            {
                title: "Estatus",
                dataIndex: "Estatus",
                key: "Estatus",
                width: 5,
                render: (value, record) => (
                    <div>
                        {!record.Estatus&&
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Error"}>
                                    <Button icon="close" style={{ color: "#BA2808", borderColor: "#BA2808" }}></Button>
                                </Tooltip>
                            </span>
                        }
                        {record.Estatus&&
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"OK"}>
                                    <Button icon="check" style={{ color: "#1B8708", borderColor: "#1B8708" }}></Button>
                                </Tooltip>
                            </span>
                        }
                    </div>
                )
            },
            {
                title: "Error",
                dataIndex: "Error",
                key: "Error",
                width: 25
            }
        ]

        return (
            <div>
                <Modal
                    title="Ver detalle SAP"
                    onCancel={() => this.props.esconderModal(false)}
                    visible={this.props.visible}
                    width={"70%"}
                    maskClosable={false}
                    confirmLoading={true}
                    centered={true}
                    footer={[
                        <Button id="boton-regresar-editar-inventario-form" className="btnCancelar" key="back" onClick={() => this.props.esconderModal(false)} > Regresar </Button>
                    ]}
                >
                    <Card id="ParentSize" title="Registro Inventario" style={{ borderRadius: "10px", borderWidth: "2px", borderColor: (this.state.arrDocsInventario.length == 0) ? '#BA2808' : "#1B8708" }}
                        extra={
                            <div>
                                {(this.state.arrDocsInventario.length == 0) &&
                                    <span style={{ fontWeight: "bold", paddingRight: "10px" }}> Ocurrio un error al registrar el inventario en SAP </span>
                                }
                                {(this.state.folioSAP == "" || this.state.arrDocsInventario.length == 0) &&
                                    <span style={{ marginRight: 5 }}>
                                        <Tooltip placement="top" title={"Error"}>
                                            <Button icon="close" style={{ color: "#BA2808", borderColor: "#BA2808", borderWidth: "2px"}}></Button>
                                        </Tooltip>
                                    </span>
                                }
                                {(this.state.folioSAP != "" && this.state.arrDocsInventario.length > 0) &&
                                    <span style={{ marginRight: 5 }}>
                                        <Tooltip placement="top" title={"OK"}>
                                            <Button icon="check" style={{ color: "#1B8708", borderColor: "#1B8708", borderWidth: "2px" }}></Button>
                                        </Tooltip>
                                    </span>
                                }
                            </div>
                        }>
                        <div className="panel-block">
                            <div style={{ marginBottom: "20px" }}>
                                <span style={{fontWeight: "bold" }}> FOLIO SAP: {this.state.folioSAP} </span>
                            </div>
                                <Spin
                                    tip="Cargando..."
                                    indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                                    spinning={this.state.cargando}
                                    style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                                    <Table size="small"
                                        locale={{ emptyText: 'No se han encontrado resultados' }}
                                        rowKey={(_, index) => index}
                                        columns={columnasErr}
                                        dataSource={this.state.dataErrors}
                                        pagination={false}
                                        scroll={{ x: '100%', y: 200 }}
                                    />
                                </Spin>
                        </div>
                    </Card>
                    <br></br>
                    <Card id="ParentSize2" title="Documentos de Inventario / Procesar Inventario" style={{ borderRadius: "10px", borderWidth: "2px", borderColor: this.state.arrDocsInventario.length == 0 ? '#BA2808' : "#1B8708" }}
                        extra={
                            <div>
                                {this.state.arrDocsInventario.length == 0 &&
                                    <span style={{ marginRight: 5 }}>
                                        <Tooltip placement="top" title={"Error"}>
                                            <Button icon="close" style={{ color: "#BA2808", borderColor: "#BA2808", borderWidth: "2px" }}></Button>
                                        </Tooltip>
                                    </span>
                                }
                                {this.state.arrDocsInventario.length != 0 &&
                                    <span style={{ marginRight: 5 }}>
                                        <Tooltip placement="top" title={"OK"}>
                                            <Button icon="check" style={{ color: "#1B8708", borderColor: "#1B8708", borderWidth: "2px" }}></Button>
                                        </Tooltip>
                                    </span>
                                }
                            </div>
                        }>
                        <div className="panel-block">
                            <div style={{ marginBottom: "20px" }}>
                                <Spin
                                    tip="Cargando..."
                                    indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                                    spinning={this.state.cargando}
                                    style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                                    <Table size="small"
                                        locale={{ emptyText: 'No se han encontrado resultados' }}
                                        rowKey={(_, index) => index}
                                        columns={columnasDocs}
                                        dataSource={this.state.arrDocsInventario}
                                        pagination={false}
                                        scroll={this.state.scroll}
                                    />
                                </Spin>
                            </div>
                        </div>
                    </Card>
                </Modal>
            </div>
        )
    }

}